import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dcfdbad4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-internal-user" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-header d-flex justify-content-between align-items-center p-0" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Create Placeholder User", -1))
const _hoisted_5 = { class: "card-body p-0" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = { class: "card-footer d-flex p-0" }
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_feather_icon = _resolveComponent("feather-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_feather_icon, {
          type: "x",
          stroke: "rgba(31, 50, 69, 0.5)",
          size: "20",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "Name",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
            onKeydown: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.name]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "Description (optional)",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.description) = $event))
          }, null, 512), [
            [_vModelText, _ctx.description]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          class: "me-1 btn btn-dark",
          onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["stop"])),
          disabled: !_ctx.name
        }, "Complete", 8, _hoisted_9),
        _createElementVNode("button", {
          class: "ms-1 btn btn-outline-dark",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('cancel')))
        }, "Cancel")
      ])
    ])
  ]))
}